import React from "react";

import fleetcoreDriverWhatsappInterfaceGuidedChatDesktop from "../../images/fleetcore-driver-whatsapp-interface-guided-chat-desktop.svg";
import fleetcoreDriverWhatsappInterfaceGuidedChatMobile from "../../images/fleetcore-driver-whatsapp-interface-guided-chat-mobile.svg";

import "./FleetCoreDriverWhatsAppInterface.css";

export default function FleetCoreDriverWhatsAppInterface() {
  return (
    <section
      className="fleetcore-driver-whatsapp-interface"
      id="fleetcore-driver-whatsapp-interface"
      aria-labelledby="fleetcore-driver-whatsapp-interface-title"
    >
      <div className="fleetcore-driver-whatsapp-interface__shell">
        <div className="fleetcore-driver-whatsapp-interface__copy">
          <p className="fleetcore-driver-whatsapp-interface__eyebrow">
            Created for drivers
          </p>
          <h2 id="fleetcore-driver-whatsapp-interface-title">
            No new app to learn. <em>Just message FleetCore.</em>
          </h2>
          <p>
            Drivers sign in, sign out and refuel inside WhatsApp. FleetCore asks
            for each photo and reading in sequence, confirms what it captured
            and completes the operational record.
          </p>
          <aside className="fleetcore-driver-whatsapp-interface__principle">
            <span aria-hidden="true">✓</span>
            <div>
              <small>Familiar interaction</small>
              <strong>
                It feels like messaging the fleet controller. Every reply
                becomes structured FleetCore evidence.
              </strong>
            </div>
          </aside>
        </div>

        <picture className="fleetcore-driver-whatsapp-interface__visual">
          <source
            media="(max-width: 620px)"
            srcSet={fleetcoreDriverWhatsappInterfaceGuidedChatMobile}
          />
          <img
            src={fleetcoreDriverWhatsappInterfaceGuidedChatDesktop}
            alt="Guided FleetCore vehicle sign-in conversation inside WhatsApp"
            loading="lazy"
          />
        </picture>
      </div>
      <p className="fleetcore-driver-whatsapp-interface__workflow-key">
        Vehicle sign-in · Vehicle sign-out · Refuelling
      </p>
    </section>
  );
}
